import { Signature, Maybe } from 'src/models';

export interface SignaturesState {
  signatures?: Maybe<Signature[]>;
}

export const INITIAL_SIGNATURES_STATE: SignaturesState = {
  signatures: undefined,
};
